import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {LastMinutesTable} from "../../UI/LastMinutes/LastMinutesTable";

const LastMinutes = () => {
  return (
    <div>
      <PanelHead title="Last Minutes" />
      <PanelBody content={<LastMinutesTable />} />
    </div>
  );
};

export default LastMinutes;
